import { getLangResources, postLangResource } from "../../api/languages";
import { createSliceWithThunks, getObjectDifference } from "../utils";

const initialState = {
  get: {
    list: null,
    status: "idle",
    error: null,
  },
  post: {
    data: null,
    status: "idle",
    error: null,
  },
};

export const resourceSlice = createSliceWithThunks({
  name: "languageSlice",
  initialState: initialState,
  reducers: (create) => ({
    resetStateLanguages: create.reducer((state, { payload }) => {
      if (payload) {
        for (let key in payload) {
          state[`${payload[key]}`] = initialState[`${payload[key]}`];
        }
      } else {
        for (let key in initialState) {
          state[key] = initialState[key];
        }
      }
    }),
    //* thunks
    fetchLangResources: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getLangResources(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.get.status = "loading";
        },
        rejected: (state, action) => {
          state.get.status = "failed";
          state.get.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.get.error = { message: respObj };
            } else if (status === "success") {
              const stored = localStorage.getItem("languageResources");
              const parsed = JSON.parse(respObj);
              const stringified = JSON.stringify(parsed);

              const hasDiff = stored
                ? Object.keys(getObjectDifference(JSON.parse(stored), parsed))
                    .length > 0
                : true;

              if (hasDiff) {
                localStorage.setItem("languageResources", stringified);
                localStorage.setItem("languageVersion", parsed?.version);
                window.location.reload();
              }

              state.get.list = parsed;
            }
          } else {
            state.get.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.get.status = "idle";
        },
      }
    ),
    addLangResource: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postLangResource(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.post.status = "loading";
        },
        rejected: (state, action) => {
          state.post.status = "failed";
          state.post.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.post.error = { message: respObj };
            } else if (status === "success") {
              state.post.data = respObj;
            }
          } else {
            state.post.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.post.status = "idle";
        },
      }
    ),
  }),
});

export const { fetchLangResources, addLangResource, resetStateLanguages } =
  resourceSlice.actions;
export default resourceSlice.reducer;
